<template>
  <div class="homeright">
    <div class="title_min">
      <div class="title_m">小程序二维码</div>
      <div class="minipImg">
        <img src="@/assets/minp.jpg">
      </div>
    </div>
    <div class="title_min">
      <div class="title_m">公众号二维码</div>
      <div class="minipImg">
        <img src="@/assets/gzh.jpg">
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.homeright {
  .title_t {
    height: 300px;
    background-color: #fff;
    border: 1px #f2f2f2 solid;
    box-shadow: 0 0 3px #ddd;
    .title_m {
      text-align: center;
      font-size: 16px;
      padding: 10px 0;
      border-bottom: 1px #e8eaec solid;
    }
  }
  .title_min {
    margin-bottom: 20px;
    height: 280px;
    background-color: #fff;
    border: 1px #f2f2f2 solid;
    box-shadow: 0 0 3px #ddd;
    .title_m {
      text-align: center;
      font-size: 16px;
      padding: 10px 0;
      border-bottom: 1px #e8eaec solid;
    }
    .minipImg {
      margin-top:10px;
      text-align: center;
      img {
        height: 210px;
        width: 210px;
      }
    }
  }
}
</style>